import React, { Fragment } from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import CloseIcon from "../../../assets/icons/close.svg";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import "./ReadOnlyApprovalModal.scss";
import ProfileWithName from "../../ListView/ListViewRows/ProfileWithName/ProfileWIthName";
import { getIntials, getName, optionalChaining } from "../../../helper";
import { sort } from "fast-sort";

function ReadOnlyApprovalModal({
  isOpen = false,
  onCloseHandler = () => console.log("No onclose handler provided"),
  approvalLevels = [],
}) {
  return (
    <Modal
      show={isOpen}
      dialogClassName={`${"approval-level-view-modal"}`}
      centered
      onHide={() => onCloseHandler()}
    >
      <Modal.Header className="align-items-center">
        <h4 className="modal-title">{"Approval Levels"}</h4>
        <img
          className="close"
          src={CloseIcon}
          alt="closeIcon"
          onClick={() => onCloseHandler()}
        />
      </Modal.Header>
      <Modal.Body className="approval-status-modal-body">
        {sort(approvalLevels)
          .asc((u) => Number(u.sequence))
          .map((approvalLevel) => {
            return (
              <Fragment>
                <Typography className="approval-status-label mb-4">
                  {approvalLevel.name}
                </Typography>
                {approvalLevel.users.map((user) => {
                  return (
                    <Card className="mb-4">
                      <CardContent className="">
                        <ProfileWithName
                          sKey={user.id}
                          nameIntial={getIntials(user)}
                          personName={getName(user)}
                          profile={optionalChaining(
                            user,
                            ["profile", "imageUrl"],
                            null
                          )}
                          isPopover={false}
                        />
                      </CardContent>
                    </Card>
                  );
                })}
              </Fragment>
            );
          })}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn-secondary"
          data-dismiss="modal"
          onClick={onCloseHandler}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

ReadOnlyApprovalModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  approvalLevels: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        nameInitial: PropTypes.string.isRequired,
        avatarUrl: PropTypes.string,
        id: PropTypes.number.isRequired,
        levelOrder: PropTypes.number.isRequired,
        isApproved: PropTypes.bool.isRequired,
      })
    )
  ),
};

export default ReadOnlyApprovalModal;

// Helper component
